import { render, staticRenderFns } from "./AddDrainageCommodity.vue?vue&type=template&id=79fefc16&scoped=true"
import script from "./AddDrainageCommodity.vue?vue&type=script&lang=ts"
export * from "./AddDrainageCommodity.vue?vue&type=script&lang=ts"
import style0 from "./AddDrainageCommodity.vue?vue&type=style&index=0&id=79fefc16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.9_css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_p_rtqrtxx4ab5lun7j52al72xaei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fefc16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79fefc16')) {
      api.createRecord('79fefc16', component.options)
    } else {
      api.reload('79fefc16', component.options)
    }
    module.hot.accept("./AddDrainageCommodity.vue?vue&type=template&id=79fefc16&scoped=true", function () {
      api.rerender('79fefc16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddDrainageCommodity.vue"
export default component.exports